import { EnumFormaPagamento } from "services";
import { PAYMENT_METHOD_KEYS } from "./constants";

export interface FormPaymentProps {
  method: EnumFormaPagamento | null;
  onValid?: (isValid: boolean) => void;
  setCurrentValue?: (value: number, index: number) => void;
  is2MethodsChildren?: boolean;
  index?: number;
}

export interface FormPaymentInternalParams {
  method: EnumFormaPagamento;
  key: KEYS_PAYMENT_METHOD_KEYS;
  amount: number;
  is2MethodsChildren: boolean;
  onValid?: (isValid: boolean) => void;
  setCurrentValue?: (value: number, index: number) => void;
  index?: number;
}

export enum EnumPaymentMethod {
  DEBITO = "debit",
  CREDITO = "credit",
  PIX = "pix",
}

export type KEYS_PAYMENT_METHOD_KEYS = keyof typeof PAYMENT_METHOD_KEYS | EnumFormaPagamento.MULTIPLE;
export type PaymentMethodValues = (typeof PAYMENT_METHOD_KEYS)[keyof typeof PAYMENT_METHOD_KEYS];